import React from 'react';

import { Container } from '@soluto-design/react';

import AccordionText, {
    AccordionTextProps,
} from '../../molecules/AccordionText';

export interface Accordion3SectionProps {
    items: AccordionTextProps[];
}

export default function Accordion3Section({ items }: Accordion3SectionProps) {
    return (
        <section className="my-mega">
            <Container>
                {!!items.length && (
                    <div className="flex flex-col gap-16">
                        {items.map(({ title, text }) => {
                            return (
                                <AccordionText
                                    title={title}
                                    text={text}
                                    key={`faq-item-${title}`}
                                />
                            );
                        })}
                    </div>
                )}
            </Container>
        </section>
    );
}
